import { LocalStorageKey } from '@ankr.com/auth';

export const getIsMarketingAccepted = () => {
  const value = localStorage.getItem(LocalStorageKey.IsMarketingAccepted);

  return value ? value === 'true' : undefined;
};
